import DOMPurify from 'dompurify';

export const sanitizeClientInput = (value: string): string => {
  return DOMPurify.sanitize(value, { ALLOWED_TAGS: [], ALLOWED_ATTR: [] });
};
